// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const shadows = {
 "xLarge": "0px 12px 48px rgba(0, 0, 0, 0.15)",
 "large": "0px 8px 24px rgba(0, 0, 0, 0.1)",
 "medium": "0px 3px 5px rgba(0, 0, 0, 0.05)",
 "small": "0px 1px 0px rgba(0, 0, 0, 0.05)"
}

export default shadows;